<template>
<div>
<div class="basic-margin cd-title-label"><b>数据对比</b>
  <el-col style="cursor:pointer;padding-left:77px;margin-top:-22px;">
    <el-tooltip placement="top" >
    <div slot="content">
      今日数据为当前实时数据，昨日数据为昨日0点到今日0点的数据<br/><br/>
      页面PV：指频道页访问量，每打开一次页面PV计数+1，刷新页面PV也计数+1<br/><br/>
      访问UV：指频道页访问人数，在同一个计算时段内不管同个IP访问多少次均计算为1次<br/><br/>
      线索量：指通过频道页收集的线索条数<br/><br/>
      总线索收入：指收集的线索成功转化成收益的金额<br/><br/>
      渠道商收入：指线索销售给合伙人得到的收益<br/><br/>
      车小花收入：指车小花线索收入-渠道线索收入
      </div>
      <span class="el-icon-information" ></span>
    </el-tooltip>
  </el-col>
</div>
  <el-table
    :data="datas"
    style="width: 100%"
    :row-class-name="tableRowClassName">
    <el-table-column
      label="日期">
      <template scope="scope">
        <el-icon name="time"></el-icon>
        <span style="margin-left: 10px">{{ scope.row.dayName }}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="pvCount"
      label="页面pv">
    </el-table-column>
    <el-table-column
      prop="uvCount"
      label="访问uv">
    </el-table-column>
    <el-table-column
      prop="clueCount"
      label="线索量">
    </el-table-column>
    <el-table-column
      label="总线索收入">
      <template scope="scope">
        <span v-if="scope.row.clueAllIncome">{{ scope.row.clueAllIncome}}</span>
        <span v-else>0</span>
      </template>
    </el-table-column>
    <el-table-column
      label="渠道商收入">
      <template scope="scope">
        <span v-if="scope.row.clueIncome">{{scope.row.clueIncome}}</span>
        <span v-else>0</span>
      </template>
    </el-table-column>
    <el-table-column
      label="车小花收入">
      <template scope="scope">
        <span v-if="scope.row.clueIncome&&scope.row.clueAllIncome">{{parseInt(scope.row.clueAllIncome)-parseInt(scope.row.clueIncome)}}</span>
        <span v-else>0</span>
      </template>
    </el-table-column>
  </el-table>
</div>
</template>
<style media="screen" >
  .el-table .info-row {
    background: #c9e5f5;
  }
  .el-table .positive-row {
    background: #e2f0e4;
  }
  .cd-title-label{
    color: rgb(32, 160, 255);
    font-size: 17px;
    margin-bottom: 10px;
  }

</style>
<script>
import DataMonitorModel from '../../../framework/models/dataMonitorModel'
import BasicPager from '../../../mixins/BasicPager'
export default {
  name: 'clue-data-monitor-reveal',
  extends: BasicPager,
  data: function () {
    return {
      datas: [
      ]
    }
  },
  created: function () {
    this.loadList()
  },
  props: {
  },
  methods: {
    tableRowClassName (row, index) {
      if (index === 0) {
        return 'info-row'
      } else if (index === 1) {
        return 'positive-row'
      }
      return ''
    },
    loadList: function () {
      let _this = this
      let params = {
      }
      let listener = {
        success: function (dataInfo) {
          dataInfo.datas.todayData.dayName = '今日'
          dataInfo.datas.yesterdayData.dayName = '昨日'
          _this.datas.push(dataInfo.datas.todayData)
          _this.datas.push(dataInfo.datas.yesterdayData)
        }
      }

      DataMonitorModel.getDataCompare(this, params, listener)
    }
  }
}
</script>
